import * as React from 'react';
import styles from './index.less';
import img_Banner3_1 from '@/assets/home/banner3-1.png';
import img_Banner3_2 from '@/assets/home/banner3-2.png';
import img_Banner3_3 from '@/assets/home/banner3-3.png';
import Notice from './Notice';
import Banner1 from './Banner1';
import Banner2 from './Banner2';
import FComponentsLib from '@freelog/components-lib';
import Ads from '@/pages/home/Ads';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import FPageFooter from '@/components/FPageFooter';
import { Helmet } from 'umi';

// declare const wx: any;

interface HomePageProps {}

function HomePage({}: HomePageProps) {
  const [topLink, set_topLink] = React.useState<string>(
    FI18n.i18nNext.tAuto('beta_event_guideline_contest_link'),
  );

  AHooks.useMount(async () => {
    self._czc?.push(['_trackPageview', self.location.pathname]);
  });


  return (
    <>
      <Helmet>
        <title>{`Freelog - 创作盛放之地`}</title>
      </Helmet>
      <div style={{ width: '100vw', overflow: 'hidden' }}>
        <Notice />

        <Banner1 />

        <Banner2 />

        <div className={styles.banner3}>
          <div style={{ height: 150 }} />
          <h1 className={styles.banner3H1}>{FI18n.i18nNext.tAuto('home_features')}</h1>
          <div style={{ height: 20 }} />
          <h3 className={styles.banner3H2}>{FI18n.i18nNext.tAuto('home_features_descr')}</h3>
          <div style={{ height: 150 }} />

          <div className={styles.banner3_Content}>
            <img src={img_Banner3_1} alt={''} className={styles.banner3_Content_LeftImg} />
            <div />
            <div className={styles.banner3_Content_Display}>
              <div className={styles.banner3_Content_DisplayH1}>
                {FI18n.i18nNext.tAuto('home_features_01')}
              </div>
              <div style={{ height: 30 }} />
              <div className={styles.banner3_Content_DisplayH2}>
                {FI18n.i18nNext.tAuto('home_features_01_descr')}
              </div>
              <div style={{ height: 30 }} />
              <FComponentsLib.FRectBtn
                style={{ height: 42, fontSize: 16 }}
                onClick={() => {
                  self._czc?.push(['_trackEvent', '首页', '进一步了解', '', 1]);
                  self.open(FI18n.i18nNext.tAuto('btn_features_01_link'));
                }}
              >
                {FI18n.i18nNext.tAuto('btn_learnmore')}
              </FComponentsLib.FRectBtn>
            </div>
          </div>

          <div style={{ height: 100 }} />

          <div className={styles.banner3_Content}>
            <img src={img_Banner3_2} alt={''} className={styles.banner3_Content_RightImg} />
            <div className={styles.banner3_Content_Display}>
              <div className={styles.banner3_Content_DisplayH1}>
                {FI18n.i18nNext.tAuto('home_features_02')}
              </div>
              <div style={{ height: 30 }} />
              <div className={styles.banner3_Content_DisplayH2}>
                {FI18n.i18nNext.tAuto('home_features_02_descr')}
              </div>
              <div style={{ height: 30 }} />
              <FComponentsLib.FRectBtn
                style={{ height: 42, fontSize: 16 }}
                onClick={() => {
                  self._czc?.push(['_trackEvent', '首页', '进一步了解', '', 1]);
                  self.open(FI18n.i18nNext.tAuto('btn_features_02_link'));
                }}
              >
                {FI18n.i18nNext.tAuto('btn_learnmore')}
              </FComponentsLib.FRectBtn>
            </div>
            <div />
          </div>

          <div style={{ height: 100 }} />

          <div className={styles.banner3_Content}>
            <img src={img_Banner3_3} alt={''} className={styles.banner3_Content_LeftImg} />
            <div />
            <div className={styles.banner3_Content_Display}>
              <div className={styles.banner3_Content_DisplayH1}>
                {FI18n.i18nNext.tAuto('home_features_03')}
              </div>
              <div style={{ height: 30 }} />
              <div className={styles.banner3_Content_DisplayH2}>
                {FI18n.i18nNext.tAuto('home_features_03_descr')}
              </div>
              <div style={{ height: 30 }} />
              <FComponentsLib.FRectBtn
                onClick={() => {
                  self._czc?.push(['_trackEvent', '首页', '进一步了解', '', 1]);
                  self.open(FI18n.i18nNext.tAuto('btn_features_03_link'));
                }}
                style={{ height: 42, fontSize: 16 }}
              >
                {FI18n.i18nNext.tAuto('btn_learnmore')}
              </FComponentsLib.FRectBtn>
            </div>
          </div>

          <div style={{ height: 150 }} />
        </div>
        <div className={styles.banner4}>
          <h1 className={styles.banner4H1}>{FI18n.i18nNext.tAuto('home_cta')}</h1>
          <div style={{ height: 40 }} />
          <h3 className={styles.banner4H2}>{FI18n.i18nNext.tAuto('home_cta_descr')}</h3>
          <div style={{ height: 40 }} />
          <FComponentsLib.FRectBtn
            style={{
              height: 60,
              fontSize: 22,
              padding: '0 50px',
              fontWeight: 400,
            }}
            onClick={() => {
              self._czc?.push(['_trackEvent', '首页', '免费使用', '', 1]);
              window.location.href =
                FUtil.Tool.getUserIDByCookies() === -1
                  ? FUtil.Format.completeUrlByDomain('user') + FUtil.LinkTo.logon()
                  : FUtil.Format.completeUrlByDomain('console');
            }}
          >
            {FI18n.i18nNext.tAuto('btn_getitforfree')}
          </FComponentsLib.FRectBtn>
        </div>

        <FPageFooter />

        <Ads />
      </div>
    </>
  );
}

export default HomePage;
